module.exports = __webpack_public_path__ + "assets/img/intro-vip-a1.31327baf.jpg";